import React, { useState } from 'react'

import { Box, Input, InputGroup, InputRightElement } from '@chakra-ui/react'

import { InterviewType } from '@pkg/types/interview'

import { SearchIcon } from '@/views/assets/SearchIcon'
import { NAME_FILTER_KEY } from '@/views/screens/Home/FilterHeader/const'

export interface NameFilterProps {
  nameFilter: string
  setNameFilter: React.Dispatch<React.SetStateAction<string>>
  selectedTab: InterviewType
}

export function NameFilter({
  nameFilter,
  setNameFilter,
  selectedTab,
}: NameFilterProps) {
  const [isNameFilterFocused, setIsNameFilterFocused] = useState(false)

  function handleFilterChange(value: string): void {
    setNameFilter(value)
    const filterKey =
      NAME_FILTER_KEY + (selectedTab === 'INTAKE' ? '-intake' : '')
    localStorage.setItem(filterKey, value)
  }

  return (
    <InputGroup
      cursor="text"
      transition="max-width 0.2s ease"
      maxW={
        selectedTab === 'INTAKE'
          ? '230px'
          : isNameFilterFocused || nameFilter
            ? '200px'
            : '150px'
      }
    >
      <Input
        fontWeight="bold"
        ml={-2}
        pr={9}
        variant="brand-solid-white"
        bg={isNameFilterFocused || nameFilter ? 'white' : 'transparent'}
        placeholder={selectedTab === 'INTAKE' ? 'Hiring Manager' : 'Candidate'}
        _placeholder={{
          color: isNameFilterFocused ? 'blackAlpha.500' : 'black',
        }}
        border={0}
        onChange={(event) => handleFilterChange(event.target.value)}
        onFocus={() => setIsNameFilterFocused(true)}
        onBlur={() => setIsNameFilterFocused(false)}
        _hover={{ bg: 'white' }}
        id="nameFilterInput"
        value={nameFilter}
      />
      <Box as="label" htmlFor="nameFilterInput" cursor="text">
        <InputRightElement
          display="flex"
          alignItems="center"
          justifyContent="center"
          h="100%"
          mr={1}
        >
          <SearchIcon w="14px" h="14px" />
        </InputRightElement>
      </Box>
    </InputGroup>
  )
}
